var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99996 2.33329C4.42263 2.33329 2.33329 4.42263 2.33329 6.99996C2.33329 9.57729 4.42263 11.6666 6.99996 11.6666C9.57729 11.6666 11.6666 9.57729 11.6666 6.99996C11.6666 4.42263 9.57729 2.33329 6.99996 2.33329ZM1.16663 6.99996C1.16663 3.7783 3.7783 1.16663 6.99996 1.16663C10.2216 1.16663 12.8333 3.7783 12.8333 6.99996C12.8333 10.2216 10.2216 12.8333 6.99996 12.8333C3.7783 12.8333 1.16663 10.2216 1.16663 6.99996Z",
    fill: "#94A3B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00708 3.71693C7.32925 3.71693 7.59041 3.9781 7.59041 4.30026L7.59042 7.82295C7.59042 8.14512 7.32925 8.40628 7.00708 8.40628C6.68492 8.40628 6.42375 8.14512 6.42375 7.82295L6.42375 4.30026C6.42375 3.9781 6.68491 3.71693 7.00708 3.71693Z",
    fill: "#94A3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58842 9.77321C7.58842 10.0954 7.32725 10.3565 7.00509 10.3565H6.99809C6.67592 10.3565 6.41475 10.0954 6.41475 9.77321C6.41475 9.45105 6.67592 9.18988 6.99809 9.18988H7.00509C7.32725 9.18988 7.58842 9.45105 7.58842 9.77321Z",
    fill: "#94A3B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00509 3.69243C7.32725 3.69243 7.58842 3.9536 7.58842 4.27577L7.58842 7.79845C7.58842 8.12062 7.32725 8.38179 7.00509 8.38179C6.68292 8.38179 6.42175 8.12062 6.42175 7.79846L6.42175 4.27577C6.42175 3.9536 6.68292 3.69243 7.00509 3.69243Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.41d6f4d94cffb8d2f053421c831f96f2.svg";
export { ForwardRef as ReactComponent };